import { Serializable } from './i-serializable';

/**
 * 패킷 진행 상태
 * 0:결제완료 1:진행 2:일시중지 3:만료 4:환불 5:미등록
 * @enum
 */
enum PacketStatus {
    DONE,
    IN_PROGRESS,
    PAUSED,
    TERMINATED,
    REPAID,
    NO_REG,
}

export class Packet implements Serializable<Packet> {

  /**
   * 패킷 진행 상태
   * 0:결제완료 1:진행 2:일시중지 3:만료 4:환불
   */
  public static STATUS = PacketStatus;

  /**
   * 패킷 프로그램 명
   */
  private $program: string = '-';

  /**
   * 패킷 총 횟수
   */
  private $total: number = 0;

  /**
   * 패킷 출석 수
   */
  private $attend: number = 0;

  /**
   * 패킷 남은 횟수
   */
  private $remain: number = 0;

  /**
   * 패킷 추가 횟수 (서비스)
   */
  private $service: number = 0;

  /**
   * 패킷 시작 일자
   */
  private $start: Date;

  /**
   * 패킷 종료 일자
   */
  private $end: Date;

  /**
   * 패킷 진행 상태
   */
  private $status: PacketStatus;

  /**
   * 타입없는 객체를 받아서 타입에 맞게 변환함
   * @param {Object} [input] deserialize 할 객체
   * @constructor
   */
  constructor(input?: Object) {
    if (input) {
      this.deserialize(input);
    }
  }

  /**
   * @override
   */
  deserialize(input: any): Packet {
    this.$program = input.name;
    this.$total = input.total || 0;
    this.$attend = input.attend || 0;
    this.$remain = input.remain || 0;
    this.$service = input.service || 0;
    this.$start = input.start ? new Date(input.start) : null;
    this.$end = input.end ? new Date(input.end) : null;
    this.$status = input.status;
    return this;
  }

  /** @return {string} 프로그램 이름 */
  get program(): string { return this.$program; }

  /** @return {number} 총 횟수 */
  get total(): number { return this.$total; }

  /** @return {number} 출석 수 */
  get attend(): number { return this.$attend; }

  /** @return {number} 남은 횟수 */
  get remain(): number { return this.$remain; }

  /** @return {number} 패킷 추가 횟수 (서비스)) */
  get service(): number { return this.$service; }

  /** @return {Date?} 패킷 시작 일자 */
  get start(): Date { return this.$start; }

  /** @return {Date?} 패킷 종료 일자 */
  get end(): Date { return this.$end; }

  /** @return {number} 패킷 진행 상태 */
  get status(): PacketStatus { return this.$status; }
}
